import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from '../../shared/i18n';
import { SuccessState, PendingState, FailureState, WaitingState } from './components';
import { determinePaymentState } from './utils';
import { PAYMENT_STATUS } from './constants';
import * as S from './GraciasPage.styles';

/**
 * Página de confirmación de pago de MercadoPago
 * 
 * Esta página maneja diferentes estados de pago:
 * - success: Pago aprobado
 * - pending: Pago pendiente de aprobación
 * - failure: Pago rechazado
 * - waiting: Sin información de pago
 * 
 * Parámetros de URL esperados:
 * - status: Estado del pago (success, pending, failure)
 * - collection_status: Estado alternativo (approved, pending, rejected)
 * - payment_id: ID de la transacción
 * - merchant_order_id: ID de la orden del comerciante
 */
function GraciasPage() {
  const t = useTranslation();
  const [searchParams] = useSearchParams();
  const [paymentState, setPaymentState] = useState(PAYMENT_STATUS.WAITING);
  const [paymentId, setPaymentId] = useState('');
  
  useEffect(() => {
    const { paymentState: state, paymentId: id } = determinePaymentState(searchParams);
    setPaymentState(state);
    setPaymentId(id);
  }, [searchParams]);
  
  // Renderizar contenido según el estado
  const renderContent = () => {
    const stateProps = { t, paymentId };
    
    switch (paymentState) {
      case PAYMENT_STATUS.SUCCESS:
        return <SuccessState {...stateProps} />;
      
      case PAYMENT_STATUS.PENDING:
        return <PendingState {...stateProps} />;
      
      case PAYMENT_STATUS.FAILURE:
        return <FailureState t={t} />;
      
      case PAYMENT_STATUS.WAITING:
      default:
        return <WaitingState t={t} />;
    }
  };
  
  return (
    <S.PageContainer>
      <S.HeroSection>
        <S.HeroBackground />
        <S.HeroContent>
          {renderContent()}
        </S.HeroContent>
      </S.HeroSection>
    </S.PageContainer>
  );
}

export default GraciasPage;

